import React, { useEffect, useState } from 'react';
import { IStepsContext, StepsContext } from './StepsContext';
import { StepsProviderProps } from './interfaces';

export const StepsProvider: React.FC<React.PropsWithChildren<StepsProviderProps>> = (props) => {
    const {
        children,
        _internalChildren,
        titles,
        submitLoading = false,
        onSubmit,
        onStepChange,
        stepsClickable = true,
    } = props;

    const [steps, setSteps] = useState<React.ReactNode[]>([]);
    const [stepNumber, setStepNumber] = useState<number>(0);
    const [allowedSteps, setAllowedSteps] = useState<number[]>([]);
    const [errorSteps, setErrorSteps] = useState<number[]>([]);
    const [warningSteps, setWarningSteps] = useState<number[]>([]);

    useEffect(() => {
        const steps = Array.isArray(_internalChildren) ? _internalChildren : [_internalChildren];
        setSteps(steps.filter((step) => !!step));
        setAllowedSteps(Array.from(Array(10).keys()));
    }, [_internalChildren, setSteps]);

    useEffect(() => {
        onStepChange?.(stepNumber);
    }, [stepNumber, onStepChange]);

    const value: IStepsContext = {
        steps,
        stepNumber,
        setStepNumber,
        titles: titles || [],
        allowedSteps,
        setAllowedSteps,
        errorSteps,
        setErrorSteps,
        warningSteps,
        setWarningSteps,
        submitLoading,
        onSubmit,
        stepsClickable,
    };

    return <StepsContext.Provider value={value}>{children}</StepsContext.Provider>;
};
